import { render } from "./PaginationContainer.vue?vue&type=template&id=047d8054&scoped=true"
import script from "./PaginationContainer.vue?vue&type=script&lang=js"
export * from "./PaginationContainer.vue?vue&type=script&lang=js"

import "./PaginationContainer.vue?vue&type=style&index=0&id=047d8054&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047d8054"]])

export default __exports__